import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getAnswerSuccess = (state) => state.answerSuccess;
export const getQuestions = (state) => state.questions;
export const getBasicQuestions = (state) => state.basicQuestions;
export const getSpecificQuestions = (state) => state.specificQuestions;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getAnswerSuccess,
    getDataList,
    getTotal,
    getId,
    getQuestions,
    getBasicQuestions,
    getSpecificQuestions,
};
